import React, { Fragment } from "react";
import localForage from "localforage";
import { host_url } from "../app-config";
import withAppData from "./withAppData";

const withDataLog = WrappedComponent => {
	const WithHOC = props => {
		async function updateDataLog(name, url, text) {
			try {
				if (
					!(navigator.serviceWorker && navigator.serviceWorker.controller) &&
					!navigator.onLine
				) {
					props.context.showOfflineNotif({
						header: "You are currently offline",
						showHeader: true,
						details: "Please check your internet connection and try again",
					});
					return { error: "network error" };
				}
				if (!name || !url) {
					return {};
				}
				let jsonHeader = await localForage.getItem("jsonHeader");
				let businessId;
				let userId;
				if (!jsonHeader) {
					return {};
				}
				businessId = Number(jsonHeader.headers.BusinessId);
				userId = Number(jsonHeader.headers.UserId);
				let newLog = [
					{
						logName: name,
						url: host_url + url,
						text: text || "",
						businessId,
						userId,
					},
				];
				let settings = await localForage.getItem("settings");
				newLog[0].createdAt = new Date().valueOf();
				if (settings) {
					if (settings.dataLog) {
						settings.dataLog = [...settings.dataLog, ...newLog];
					} else {
						settings.dataLog = newLog;
					}
				} else {
					settings = {
						dataLog: newLog,
					};
				}
				await localForage.setItem("settings", settings);
				return settings;
			} catch (error) {
				props.context.showAlert(
					`<b>Low device memory!</b><br/>Please free up some space from your ${
						window.screen.width > 1024 ? "desktop" : "phone"
					} and try again`,
					"error",
				);
				return { error };
			}
		}
		return (
			<Fragment>
				<DataLogContext.Consumer>
					{() => <WrappedComponent {...props} updateDataLog={updateDataLog} />}
				</DataLogContext.Consumer>
			</Fragment>
		);
	};
	WithHOC.WrappedComponent = WrappedComponent;
	return withAppData(WithHOC);
};

const DataLogContext = React.createContext(null);

export default withDataLog;
